module.exports = __webpack_public_path__ + "img/twitch-layout.45eefab1.jpg";